import PaneTabs from './PaneTabs';

export default PaneTabs;
